<div class="cosmetic-style-options-menu" appDelayedMouseleave (appDelayedMouseleave)="closeMenu()" (click)="$event.stopPropagation()">
  <button type="button" class="btn options-menu-toggle" title="Style options" [disabled]="disabled"
    (click)="toggleMenu($event)">⋯</button>

  @if (menuOpen) {
    <div class="options-menu-panel" (click)="onPanelClick($event)">
      <ng-content></ng-content>
      <div class="options-menu-separator"></div>
      <button type="button" class="btn options-menu-item" [disabled]="disabled || !canCopyStyle" (click)="copyStyle()">
        <span class="icon icon-copy options-menu-icon" aria-hidden="true"></span>
        <span class="options-menu-label">Copy style</span>
      </button>
      <button type="button" class="btn options-menu-item" [disabled]="disabled || !hasClipboard()" (click)="pasteStyle()">
        <span class="icon icon-paste options-menu-icon" aria-hidden="true"></span>
        <span class="options-menu-label">Paste style</span>
      </button>
      <button type="button" class="btn options-menu-item" [disabled]="disabled || !hasLibraryEntries()" (click)="openLibraryPicker()">
        <span class="icon icon-drawer options-menu-icon" aria-hidden="true"></span>
        <span class="options-menu-label">From Library</span>
      </button>
    </div>
  }
</div>

@if (libraryPickerOpen) {
  <app-style-library-picker-dialog
    [rarity]="rarity"
    [sockets]="sockets"
    [influence]="influence"
    [fractured]="fractured"
    [veiled]="veiled"
    [isCurrency]="isCurrency"
    [isWaystone]="isWaystone"
    [isPoe1Gem]="isPoe1Gem"
    [isDivinationCard]="isDivinationCard"
    [isQuestItem]="isQuestItem"
    [forceHidden]="forceHidden"
    (selected)="onLibrarySelected($event)"
    (close)="closeLibraryPicker()">
  </app-style-library-picker-dialog>
}
